module.exports = __webpack_public_path__ + "img/Diagnosis - Pink - Selected.b9a100fc.png";